// extracted by mini-css-extract-plugin
export default {"success":"ResetPasswordPage_success__dV1Or","errorText":"ResetPasswordPage_errorText__g3Yms","backLink":"ResetPasswordPage_backLink__kcuFd"};